// import { API_CONFIG } from './constants';

/**
 * Get the base URL for serving uploaded assets (uploads folder).
 * Falls back to deriving from API URL when REACT_APP_ASSET_URL is not set.
 */
function getAssetBaseUrl(): string {
  const explicit = process.env.REACT_APP_ASSET_URL;
  if (explicit) return explicit.replace(/\/$/, ''); // trim trailing slash
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3002/api';
  // Use /api/static/uploads when Nginx only proxies /api/* (avoids "route not found")
  const base = apiUrl.replace(/\/api\/?$/, '');
  return base + '/api/static/uploads';
}

/**
 * Utility function to generate full asset URLs
 * @param path - The relative path to the asset (e.g. /website-config/abc.jpg or website-config/abc.jpg)
 * @returns Full URL to the asset
 */
export const getAssetUrl = (path: string): string => {
  if (!path) return '';
  
  // If it's a remote URL (not localhost), normalize legacy /uploads to /api/static/uploads
  if (path.startsWith('http') && !path.includes('localhost')) {
    if (path.includes('api.funddharma.com/uploads/')) {
      return path.replace('api.funddharma.com/uploads/', 'api.funddharma.com/api/static/uploads/');
    }
    return path;
  }
  
  // Strip localhost variations if present
  let cleanPath = path;
  if (cleanPath.startsWith('http://localhost:3002/uploads')) {
    cleanPath = cleanPath.replace('http://localhost:3002/uploads', '');
  } else if (cleanPath.startsWith('http://localhost:3002')) {
    cleanPath = cleanPath.replace('http://localhost:3002', '');
  }
  
  // Remove /uploads prefix to avoid duplicate (asset base already ends with /uploads)
  if (cleanPath.startsWith('/uploads')) {
    cleanPath = cleanPath.substring('/uploads'.length);
  } else if (cleanPath.startsWith('uploads/')) {
    cleanPath = cleanPath.substring(7);
  }
  
  // Remove leading slash
  cleanPath = cleanPath.startsWith('/') ? cleanPath.substring(1) : cleanPath;
  
  const assetBaseUrl = getAssetBaseUrl();
  return cleanPath ? `${assetBaseUrl}/${cleanPath}` : assetBaseUrl;
};

const utilsExport = {
  getAssetUrl
};

export default utilsExport;